<template>
  <div class="vendor-form.documents mt-4">
    <!-- Action Buttons -->
    <div class="d-flex justify-content-end mb-3">
      <template v-if="!hasAnyRowEditing">
        <b-button
          v-if="!isDetail"
          variant="danger"
          size="sm"
          class="mr-2"
          :disabled="!rowIndexSelecteds.length"
          @click="deleteSelected"
        >
          <i class="fas fa-trash-alt"></i>
          Delete Selected
        </b-button>
        <b-button variant="outline-primary" size="sm" @click="addRow">
          <i class="fas fa-plus"></i>
          Add New Row
        </b-button>
      </template>
      <template v-else>
        <b-button variant="primary" size="sm" @click="onSaveUpdate">
          <i class="fa fa-floppy-o"></i>
          Save Update
        </b-button>
        <b-button
          class="ml-2"
          variant="outline-secondary"
          size="sm"
          @click="cancelUpdate"
        >
          Cancel Update
        </b-button>
      </template>
    </div>

    <!-- Native Table -->
    <table class="table align-middle">
      <thead class="thead-light">
        <tr>
          <th v-if="!isDetail" class="text-center" style="width: 48px">
            <b-form-checkbox
              :disabled="!form.documents.length"
              :checked="rowIndexSelecteds.length === form.documents.length"
              @input="toggleAll"
            />
          </th>
          <th v-if="isDetail" class="text-center align-middle" style="width: 48px">
            <i
              class="fa"
              :class="allRowsEditing ? 'fa-trash-alt text-danger' : 'fa-edit text-primary'"
              :title="allRowsEditing ? 'Delete All Rows' : 'Edit Semua Baris'"
              @click="allRowsEditing ? deleteAll() : toggleAllRowsEdit()"
            />
          </th>
          <th>Action</th>
          <th>Document Name</th>
          <th>Shipment Plan Detail Number</th>
          <th>Document Upload</th>
          <th v-if="!isDetail" style="width: 40px"></th>
        </tr>
      </thead>
      <tbody>
        <template v-if="form.documents?.length">
          <tr v-for="(doc, index) in form.documents" :key="index">
            <td v-if="!isDetail" class="text-center" valign="center" style="width: 48px">
              <b-form-checkbox :value="index" v-model="rowIndexSelecteds" />
            </td>
            <td v-if="!isDetail" class="text-center" style="width: 48px">
              <b-button
                variant="link"
                size="sm"
                class="text-danger p-0"
                @click="deleteRow(index)"
              >
                <i class="fas fa-trash-alt"></i>
              </b-button>
            </td>
            <td v-if="isDetail" class="text-center align-center" style="width: 48px">
              <i
                class="fa"
                :class="isRowEditing(index) ? 'fa-trash-alt text-danger' : 'fa-edit text-primary'"
                :title="isRowEditing(index) ? 'Delete Row' : 'Edit Row'"
                @click="isRowEditing(index) ? deleteRow(index) : startRowEdit(index)"
              />
            </td>
            <td style="width: 34%" valign="center">
              <template v-if="!isDetail">
                <b-form-input v-model="doc.fileName" size="sm"></b-form-input>
              </template>
              <template v-else>
                <template v-if="isRowEditing(index)">
                  <b-form-input v-model="doc.fileName" size="sm"></b-form-input>
                </template>
                <template v-else>
                  <span class="form-control-plaintext">
                    {{ doc.fileName || '-' }}
                  </span>
                </template>
              </template>
            </td>
            <td style="width: 34%" valign="center">
              <template v-if="!isDetail">
                <b-form-select
                  v-model="doc.shipmentPlanDetailNumber"
                  :options="shipmentNumberOptions"
                  size="sm"
                  class="bg-white"
                  plain
                >
                  <template #first>
                    <option :value="null" disabled>
                      Select Shipment Plan Detail Number
                    </option>
                  </template>
                </b-form-select>
              </template>
              <template v-else>
                <template v-if="isRowEditing(index)">
                  <b-form-select
                    v-model="doc.shipmentPlanDetailNumber"
                    :options="shipmentNumberOptions"
                    size="sm"
                    class="bg-white"
                    plain
                  >
                    <template #first>
                      <option :value="null" disabled>
                        Select Shipment Plan Detail Number
                      </option>
                    </template>
                  </b-form-select>
                </template>
                <template v-else>
                  <span class="form-control-plaintext">
                    {{ doc.shipmentPlanDetailNumber || '-' }}
                  </span>
                </template>
              </template>
            </td>
            <td style="width: 34%" valign="center">
              <template v-if="!isDetail">
                <div class="d-flex flex-column">
                  <b-form-file
                    v-model="doc.file"
                    size="sm"
                    browse-text="Browse"
                    placeholder="Choose file..."
                  />
                  <div>
                    <small>
                      File Type :
                      <b>.Pdf</b>
                    </small>
                    <span class="mx-2">|</span>
                    <small>
                      Max File Size :
                      <b>25 MB</b>
                    </small>
                  </div>
                </div>
              </template>
              <template v-else>
                <template v-if="isRowEditing(index)">
                  <div class="d-flex flex-column">
                    <b-form-file
                      v-model="doc.file"
                      size="sm"
                      browse-text="Browse"
                      placeholder="Choose file..."
                    />
                    <div>
                      <small>
                        File Type :
                        <b>.Pdf</b>
                      </small>
                      <span class="mx-2">|</span>
                      <small>
                        Max File Size :
                        <b>25 MB</b>
                      </small>
                    </div>
                  </div>
                </template>
                <template v-else>
                  <button
                    v-if="doc.fileUrl"
                    type="button"
                    class="btn btn-link p-0 form-control-plaintext text-left"
                    @click="openDocument(doc)"
                  >
                    {{ doc.fileName }}.{{ doc.extension }}
                  </button>
                </template>
              </template>
            </td>
          </tr>
        </template>
        <template v-else>
          <tr>
            <td colspan="3">No Documnet Needed!</td>
          </tr>
        </template>
      </tbody>
    </table>
  </div>
</template>

<script>
import { previewFile } from '@/src/plugins/helpers';
import axios from '../../../store/modules/auth'

export default {
  name: 'FormpProjectDocument',
  props: {
    isDetail: Boolean,
    form: {
      type: Object,
      default: () => ({}),
    },
    shipmentNumberOptions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      selectAll: false,
      rowIndexSelecteds: [],
      apiUrl: process.env.VUE_APP_API_BUSDEV_BASE_URL,
      originalSnapshot: null,
    }
  },
  computed: {
    hasSelected() {
      return this.form.documents.some((doc) => doc.selected)
    },
    hasAnyRowEditing() {
      return (this.form?.documents || []).some((d) => d && d._isEditing)
    },
    allRowsEditing() {
      const docs = this.form?.documents || []
      return docs.length > 0 && docs.every((d) => d && d._isEditing)
    },
  },
  methods: {
    addRow() {
      const newDoc = {
        fileName: '',
        shipmentPlanDetailNumber: null,
        file: null,
        fileUrl: '',
        extension: '',
        _isEditing: !!this.isDetail, // auto edit in detail view
      }
      if (!Array.isArray(this.form.documents)) {
        this.$set(this.form, 'documents', [])
      }
      // if entering edit mode for the first time in detail, take snapshot
      if (this.isDetail && !this.hasAnyRowEditing && !this.originalSnapshot) {
        this.originalSnapshot = JSON.parse(
          JSON.stringify(this.form?.documents || [])
        )
      }
      this.form.documents.push(newDoc)
    },
    onSaveUpdate() {
      // Emit submit so parent can persist, then clear edit state
      this.$emit('submit')
      this._clearAllEditFlags()
      this.originalSnapshot = null
    },
    deleteRow(index) {
      this.form.documents.splice(index, 1)
    },
    deleteSelected() {
      this.form.documents = this.form.documents.filter(
        (doc, idx) => !this.rowIndexSelecteds.includes(idx)
      )
      this.rowIndexSelecteds = []
    },
    toggleAll(val) {
      if (val) {
        this.rowIndexSelecteds = this.form.documents.map((doc, idx) => idx)
      } else {
        this.rowIndexSelecteds = []
      }
    },
    updateSelectAll() {
      this.selectAll = this.form.documents.every((doc) => doc.selected)
    },
    ensureEditStateRow(index) {
      const docs = this.form?.documents || []
      if (!docs[index]) return
      if (docs[index]._isEditing === undefined) this.$set(docs[index], '_isEditing', false)
      if (docs[index]._original === undefined) this.$set(docs[index], '_original', null)
    },
    isRowEditing(index) {
      const doc = (this.form?.documents || [])[index]
      return !!(doc && doc._isEditing)
    },
    startRowEdit(index) {
      this.ensureEditStateRow(index)
      // Take snapshot on first enter of edit mode
      if (!this.hasAnyRowEditing) {
        this.originalSnapshot = JSON.parse(JSON.stringify(this.form?.documents || []))
      }
      this.$set(this.form.documents[index], '_isEditing', true)
    },
    toggleAllRowsEdit() {
      const docs = this.form?.documents || []
      if (!this.hasAnyRowEditing) {
        this.originalSnapshot = JSON.parse(JSON.stringify(docs))
      }
      const makeEditing = !this.allRowsEditing
      docs.forEach((d, idx) => {
        this.ensureEditStateRow(idx)
        this.$set(d, '_isEditing', makeEditing)
      })
    },
    cancelUpdate() {
      // Revert to snapshot if available
      if (this.originalSnapshot) {
        this.$set(this.form, 'documents', JSON.parse(JSON.stringify(this.originalSnapshot)))
      }
      this.originalSnapshot = null
      this._clearAllEditFlags()
    },
    deleteAll() {
      this.form.documents = []
      this.rowIndexSelecteds = []
      this.originalSnapshot = null
    },
    _clearAllEditFlags() {
      (this.form?.documents || []).forEach((d) => {
        if (d && d._isEditing) d._isEditing = false
        if (d && d._original) d._original = null
      })
    },
    async openDocument(doc) {
      try {
        previewFile(doc.fileUrl);
        // const url = `${this.apiUrl}/download/${(doc.fileUrl || '').replace('upload/', '')}`
        // const res = await axios.get(url, { responseType: 'blob' })
        // const blob = res.data
        // const blobUrl = URL.createObjectURL(blob)
        // window.open(blobUrl, '_blank')
        // // Optional: revoke after some delay to allow load
        // setTimeout(() => URL.revokeObjectURL(blobUrl), 60_000)
      } catch (err) {
        // Basic UX feedback; adapt to your toast/alert system if present
        // eslint-disable-next-line no-alert
        alert(err?.message || 'Failed to open document')
      }
    },
  },
}
</script>

<style scoped>
.table th {
  font-weight: 600;
  font-size: 0.9rem;
}

.table td {
  vertical-align: middle;
}

.form-control,
.custom-select {
  font-size: 0.85rem;
}

.table td,
.table th {
  white-space: nowrap;
}

.table-hover tbody tr:hover {
  background-color: #f8f9fa;
}
</style>
